import { makeApolloClient, logError } from '../util';
import { POSTS, POST } from 'queries/post';
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POST = 'FETCH_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const CLEAR_POST = 'CLEAR_POST';

const fetchPosts = ({ posts, from }) => ({
	type: FETCH_POSTS,
	posts,
	from,
});

const fetchPost = ({ post, from }) => ({
	type: FETCH_POST,
	post,
	from,
});

export const updatePost = ({ post, from }) => ({
	type: UPDATE_POST,
	post,
	from,
});

export const deletePost = ({ id, from }) => ({
	type: DELETE_POST,
	postID: id,
	from,
});

export const clearPosts = () => ({
	type: CLEAR_POSTS,
});

export const clearPost = () => ({
	type: CLEAR_POST,
});

export const thunkFetchPosts = ({ event_id, offset, items_per_page }, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { posts } = await client.request(POSTS, {
			event_id,
			offset,
			items_per_page,
		});
		dispatch(fetchPosts({ posts, from }));
	} catch (error) {
		logError(error, 'posts.actions.thunkFetchPosts');
	}
};

export const thunkFetchPost = (postID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());

	try {
		const { post } = await client.request(POST, {
			id: postID,
		});
		dispatch(fetchPost({ post, from }));
	} catch (error) {
		logError(error, 'posts.actions.thunkFetchPost');
	}
};
